import IPretendente from '../../interfaces/IPretendente';
import './styles.scss';
import { DadosPessoais } from './Icones/dadosPessoais';
import AvisoInconsistencia from '../AvisoInconsistencia';

interface InativacaoDeInscricaoDadosPessoaisProps {
  titular: IPretendente;
  protocolo: string;
  mensagensDeErro: string[];
}

const InativacaoDeInscricaoDadosPessoais = ({
  titular,
  protocolo,
  mensagensDeErro,
}: InativacaoDeInscricaoDadosPessoaisProps) => {
  return (
    <>
      <div className='container-inativacao-dados-pessoais'>
        {mensagensDeErro.length
          ? mensagensDeErro.map((mensagem) => (
            <AvisoInconsistencia
              visivel={true}
              mensagemDeAlerta={mensagem}
              key={mensagem}
              titulo='Essa inscrição não pode ser inativada'
            />
          ))
          : null}

        <div className='container-dados-pessoais-titulo'>
          <DadosPessoais />
          <h2 className='cartao__titulo'>Dados Pessoais</h2>
        </div>

        <div className='container-dados-pessoais'>
          <div className='dado-pessoal'>
            <span>Nome</span>
            <p>{titular?.nome}</p>
          </div>
          <div className='dado-pessoal'>
            <span>CPF</span>
            <p>{titular?.cpf}</p>
          </div>
          <div className='dado-pessoal'>
            <span>Protocolo</span>
            <p>{protocolo}</p>
          </div>
        </div>
      </div>
    </>
  );
};
export default InativacaoDeInscricaoDadosPessoais;
